var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78585 13.3638L22.2143 13.3638C22.6482 13.3638 23 13.0178 23 12.591V1.77291C23 1.34614 22.6482 1.00018 22.2143 1.00018L1.78585 1.00018C1.35192 1.00018 1.00014 1.34614 1.00014 1.77291V12.591C1.00014 13.0178 1.35192 13.3638 1.78585 13.3638Z",
    stroke: "#5FBA99",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57178 15.6816H21.4288M4.1432 17.9998H19.8574",
    stroke: "#5FBA99",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 11.0456C14.1695 11.0456 15.9284 9.3158 15.9284 7.18198C15.9284 5.04816 14.1695 3.31836 11.9998 3.31836C9.83016 3.31836 8.07129 5.04816 8.07129 7.18198C8.07129 9.3158 9.83016 11.0456 11.9998 11.0456Z",
    stroke: "#5FBA99",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 4.86362C21.9579 4.86362 20.9587 4.45656 20.222 3.73199C19.4852 3.00742 19.0713 2.0247 19.0713 1M1 4.86362C1.5159 4.86362 2.02676 4.76369 2.50339 4.56952C2.98002 4.37536 3.4131 4.09076 3.7779 3.73199C4.1427 3.37322 4.43207 2.9473 4.6295 2.47854C4.82693 2.00979 4.92855 1.50738 4.92855 1M22.9999 9.49997C21.9579 9.49997 20.9587 9.90702 20.222 10.6316C19.4852 11.3562 19.0713 12.3389 19.0713 13.3636M1 9.49997C1.5159 9.49997 2.02676 9.5999 2.50339 9.79407C2.98002 9.98823 3.4131 10.2728 3.7779 10.6316C4.1427 10.9904 4.43207 11.4163 4.6295 11.885C4.82693 12.3538 4.92855 12.8562 4.92855 13.3636",
    stroke: "#5FBA99",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoney);
export default __webpack_public_path__ + "static/media/icon-money.bab96f324f2f87f5fa0be7b463d1f943.svg";
export { ForwardRef as ReactComponent };